import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Footer from "./Footer";
import Navbar from "./Navbar";
import ScrollToTopButton from "../ScrollToTopButton";

export default function GeneralLayout() {
  const { pathname, hash } = useLocation();

  const isHomepage = pathname === "/";

  // Scroll to top on page navigation (but not for hash navigation)
  useEffect(() => {
    // Only scroll to top if pathname changed and there's no hash
    // This prevents interfering with hash-based navigation
    if (!hash && pathname) {
      window.scrollTo(0, 0);
    }
  }, [pathname]); // Only depend on pathname, not hash

  return (
    <div className="w-full relative general-width h-fit overflow-x-hidden">
      <Navbar />
      <main className="overflow-x-hidden pt-20 smLaptop:pt-24">
        <Outlet />
      </main>
      <Footer />
      {isHomepage && <ScrollToTopButton />}
    </div>
  );
}
